<template>
  <div class="article-card-simple">
    <div class="image-wrapp">
      <img
        :src="article.image"
        class="image-wrapp__image"
      />
    </div>
    <div
      class="article-card-simple__title"
      v-html="article.title"
    />
    <a
      :href="article.url"
      :target="target || getTarget"
      class="article-card-simple__link"
      @click="sendAnalytic"
    />
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';

  export default defineNuxtComponent({
    name: 'ArticleCardSimple',
    props: {
      article: {
        required: true,
        type: Object,
      },

      target: {
        required: false,
        type: String as PropType<string | undefined>,
        default: undefined,
      },
    },

    emits: ['click-simple-article'],

    computed: {
      getTarget(): string {
        return this.article.domain === 'lifehacker.ru' ? '_self' : '_target';
      },
    },

    methods: {
      sendAnalytic() {
        this.$emit('click-simple-article', this.article);
      },
    },
  });
</script>

<style lang="scss" scoped>
  .article-card-simple {
    padding: 16px;
    position: relative;
    box-sizing: border-box;
    word-break: break-word;
    border: 1px solid #e7e7e7;
    width: calc(100% - 2px);

    @include hover {
      .article-card-simple__title {
        color: var(--main-color);
      }
      .image-wrapp__image {
        transform: scale(1.1);
      }
      &::before {
        content: '';
        position: absolute;
        height: calc(100% + 2px);
        width: calc(100% + 2px);
        box-sizing: border-box;
        border: 2px solid var(--main-color);
        left: -1px;
        top: -1px;
        z-index: 5;
      }
    }
    @include tablet {
      padding: 24px;
    }

    &__title {
      color: #000;
      margin-top: 8px;
      font-family: $secondFont;
      font-size: 18px;
      line-height: 26px;
      font-weight: 600;
      // lineclamp
      -webkit-box-orient: vertical;
      object-fit: contain;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      line-clamp: 4;
      box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &__link {
      position: absolute;
      content: '';
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 6;
    }
  }

  .image-wrapp {
    overflow: hidden;
    transform: translateZ(0);
    border-radius: 4px;
    @include tablet {
      height: 168px;
      max-width: 336px;
      width: 100%;
    }
    @include big-tablet {
      height: 146px;
      max-width: 293px;
      width: 100%;
    }
    @include desktop {
      height: 136px;
      max-width: 272px;
      width: 100%;
    }
    &__image {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: all 0.3s linear;
    }
  }
</style>
